import React from 'react'
import ChaiseImage from '../../../../assets/products/chaise-rectangle-2-breaks.webp'

const RectangleTwoBreaks = ({ totalWidth = '', totalChaiseLength = '' }) => {
  return (
    <svg width="762" height="498" viewBox="0 0 820 200" xmlns="http://www.w3.org/2000/svg">
      <image x="-250" y="-300" width="1080" height="760" xlinkHref={ChaiseImage} />
      {totalWidth && (
        <text x="381" y="70" fontSize="14" fill="#FFFFFF99">
          {totalWidth}
        </text>
      )}
      {totalChaiseLength && (
        <text x="300" y="-110" fontSize="14" fill="#FFFFFF99">
          Total length: {totalChaiseLength}
        </text>
      )}
      <g id="Group 1472">
        <g id="E-Comp">
          <g filter="url(#filter0_d_5404_8375)">
            <rect
              id="E-Background"
              x="24.4775"
              y="106.874"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-21.414 24.4775 106.874)"
              fill="transparent"
            />
            <path
              id="E-Text"
              d="M55.6159 123.018L55.571 125.074L48.7611 124.926L48.806 122.87L55.6159 123.018ZM49.9013 112.151L49.6222 124.944L46.9861 124.887L47.2652 112.093L49.9013 112.151ZM54.849 117.472L54.8052 119.475L48.8828 119.346L48.9265 117.343L54.849 117.472ZM55.8413 112.28L55.7963 114.345L48.9952 114.197L49.0402 112.132L55.8413 112.28Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="E-Line"
            d="M58.6141 36.829C58.3611 36.7185 58.0663 36.8341 57.9558 37.0872L56.1553 41.2112C56.0448 41.4643 56.1604 41.759 56.4134 41.8695C56.6665 41.98 56.9612 41.8644 57.0717 41.6114L58.6722 37.9455L62.3381 39.546C62.5911 39.6565 62.8859 39.5409 62.9964 39.2879C63.1069 39.0348 62.9913 38.7401 62.7382 38.6296L58.6141 36.829ZM111.441 173.467C111.694 173.577 111.989 173.461 112.099 173.208L113.9 169.084C114.01 168.831 113.895 168.537 113.642 168.426C113.388 168.316 113.094 168.431 112.983 168.684L111.383 172.35L107.717 170.75C107.464 170.639 107.169 170.755 107.059 171.008C106.948 171.261 107.064 171.556 107.317 171.666L111.441 173.467ZM57.9486 37.4698L58.8357 39.7318L59.7667 39.3667L58.8795 37.1047L57.9486 37.4698ZM60.6099 44.2558L62.3842 48.7799L63.3151 48.4148L61.5409 43.8907L60.6099 44.2558ZM64.1584 53.3039L65.9326 57.8279L66.8636 57.4628L65.0893 52.9388L64.1584 53.3039ZM67.7068 62.352L69.4811 66.876L70.412 66.5109L68.6378 61.9869L67.7068 62.352ZM71.2553 71.4001L73.0295 75.9241L73.9605 75.559L72.1863 71.035L71.2553 71.4001ZM74.8037 80.4481L76.578 84.9722L77.5089 84.6071L75.7347 80.083L74.8037 80.4481ZM78.3522 89.4962L80.1264 94.0202L81.0574 93.6551L79.2832 89.1311L78.3522 89.4962ZM81.9007 98.5443L83.6749 103.068L84.6059 102.703L82.8316 98.1792L81.9007 98.5443ZM85.4491 107.592L87.2233 112.116L88.1543 111.751L86.3801 107.227L85.4491 107.592ZM88.9976 116.64L90.7718 121.164L91.7028 120.799L89.9285 116.275L88.9976 116.64ZM92.546 125.688L94.3203 130.213L95.2512 129.847L93.477 125.323L92.546 125.688ZM96.0945 134.737L97.8687 139.261L98.7997 138.895L97.0255 134.371L96.0945 134.737ZM99.6429 143.785L101.417 148.309L102.348 147.944L100.574 143.42L99.6429 143.785ZM103.191 152.833L104.966 157.357L105.897 156.992L104.122 152.468L103.191 152.833ZM106.74 161.881L108.514 166.405L109.445 166.04L107.671 161.516L106.74 161.881ZM110.288 170.929L111.175 173.191L112.106 172.826L111.219 170.564L110.288 170.929Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="D-Comp">
          <g filter="url(#filter1_d_5404_8375)">
            <rect
              id="D-Background"
              x="231.835"
              y="237.323"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 231.835 237.323)"
              fill="transparent"
            />
            <path
              id="D-Text"
              d="M247.389 219.908L244.603 219.881L244.64 217.825L247.409 217.851C248.1 217.858 248.685 217.708 249.162 217.402C249.64 217.09 250.001 216.634 250.247 216.032C250.499 215.431 250.629 214.703 250.637 213.848L250.643 213.224C250.649 212.567 250.584 211.989 250.449 211.49C250.319 210.991 250.12 210.57 249.854 210.228C249.588 209.885 249.259 209.627 248.868 209.454C248.477 209.274 248.027 209.182 247.517 209.177L244.652 209.15L244.672 207.085L247.537 207.112C248.392 207.12 249.173 207.274 249.879 207.573C250.591 207.867 251.206 208.286 251.722 208.83C252.238 209.374 252.633 210.023 252.908 210.775C253.188 211.522 253.323 212.352 253.315 213.266L253.309 213.873C253.3 214.781 253.149 215.609 252.855 216.356C252.566 217.103 252.159 217.744 251.632 218.278C251.112 218.806 250.49 219.214 249.766 219.5C249.049 219.78 248.256 219.916 247.389 219.908ZM246.219 207.099L246.097 219.896L243.461 219.871L243.582 207.074L246.219 207.099Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="D-Line"
            d="M153.21 193.632C153.054 193.86 153.112 194.171 153.339 194.327L157.05 196.873C157.278 197.029 157.589 196.971 157.745 196.743C157.902 196.515 157.844 196.204 157.616 196.048L154.317 193.786L156.58 190.487C156.736 190.259 156.678 189.948 156.45 189.792C156.222 189.636 155.911 189.694 155.755 189.921L153.21 193.632ZM329.885 161.434C330.042 161.206 329.984 160.895 329.756 160.738L326.045 158.193C325.817 158.037 325.506 158.095 325.35 158.323C325.194 158.55 325.252 158.862 325.479 159.018L328.778 161.28L326.515 164.579C326.359 164.807 326.417 165.118 326.645 165.274C326.873 165.43 327.184 165.372 327.34 165.145L329.885 161.434ZM153.714 194.407L156.156 193.952L155.973 192.968L153.53 193.423L153.714 194.407ZM161.041 193.041L165.926 192.131L165.742 191.148L160.858 192.058L161.041 193.041ZM170.81 191.221L175.695 190.311L175.512 189.328L170.627 190.238L170.81 191.221ZM180.58 189.401L185.465 188.491L185.281 187.508L180.397 188.418L180.58 189.401ZM190.349 187.581L195.234 186.671L195.051 185.687L190.166 186.598L190.349 187.581ZM200.119 185.76L205.004 184.85L204.82 183.867L199.936 184.777L200.119 185.76ZM209.888 183.94L214.773 183.03L214.59 182.047L209.705 182.957L209.888 183.94ZM219.658 182.12L224.543 181.21L224.359 180.227L219.475 181.137L219.658 182.12ZM229.427 180.3L234.312 179.39L234.129 178.407L229.244 179.317L229.427 180.3ZM239.197 178.48L244.082 177.569L243.898 176.586L239.014 177.496L239.197 178.48ZM248.966 176.659L253.851 175.749L253.668 174.766L248.783 175.676L248.966 176.659ZM258.736 174.839L263.621 173.929L263.437 172.946L258.553 173.856L258.736 174.839ZM268.505 173.019L273.39 172.109L273.207 171.126L268.322 172.036L268.505 173.019ZM278.275 171.199L283.16 170.288L282.976 169.305L278.092 170.215L278.275 171.199ZM288.044 169.378L292.929 168.468L292.746 167.485L287.861 168.395L288.044 169.378ZM297.814 167.558L302.698 166.648L302.515 165.665L297.631 166.575L297.814 167.558ZM307.583 165.738L312.468 164.828L312.285 163.845L307.4 164.755L307.583 165.738ZM317.353 163.918L322.237 163.008L322.054 162.024L317.17 162.935L317.353 163.918ZM327.122 162.097L329.565 161.642L329.381 160.659L326.939 161.114L327.122 162.097Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter2_d_5404_8375)">
            <rect
              id="C-Background"
              x="414.794"
              y="202.327"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 414.794 202.327)"
              fill="transparent"
            />
            <path
              id="C-Text"
              d="M433.842 180.7L436.47 180.724C436.409 181.585 436.165 182.348 435.737 183.012C435.314 183.676 434.726 184.191 433.973 184.559C433.225 184.927 432.327 185.106 431.278 185.096C430.458 185.089 429.724 184.941 429.076 184.654C428.429 184.36 427.876 183.945 427.418 183.407C426.966 182.87 426.623 182.222 426.39 181.464C426.157 180.706 426.045 179.858 426.054 178.921L426.063 178.033C426.071 177.095 426.203 176.25 426.456 175.496C426.715 174.737 427.078 174.093 427.546 173.564C428.02 173.036 428.584 172.631 429.237 172.35C429.89 172.069 430.618 171.932 431.42 171.94C432.487 171.95 433.384 172.152 434.113 172.545C434.848 172.939 435.414 173.478 435.812 174.161C436.215 174.845 436.454 175.621 436.528 176.488L433.891 176.463C433.867 175.948 433.768 175.51 433.596 175.151C433.424 174.786 433.16 174.511 432.804 174.326C432.454 174.135 431.986 174.037 431.401 174.032C430.961 174.027 430.577 174.106 430.247 174.267C429.917 174.428 429.64 174.674 429.414 175.006C429.188 175.338 429.017 175.758 428.901 176.267C428.791 176.77 428.732 177.361 428.726 178.041L428.717 178.946C428.711 179.608 428.755 180.191 428.85 180.696C428.945 181.195 429.093 181.618 429.295 181.966C429.503 182.308 429.77 182.568 430.096 182.747C430.429 182.92 430.829 183.009 431.298 183.013C431.849 183.019 432.304 182.935 432.663 182.763C433.022 182.59 433.297 182.332 433.487 181.988C433.684 181.644 433.802 181.215 433.842 180.7Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M342.676 157.424C342.519 157.651 342.577 157.963 342.805 158.119L346.516 160.664C346.744 160.82 347.055 160.762 347.211 160.535C347.367 160.307 347.309 159.996 347.082 159.84L343.783 157.577L346.046 154.278C346.202 154.051 346.144 153.739 345.916 153.583C345.688 153.427 345.377 153.485 345.221 153.713L342.676 157.424ZM506.338 127.65C506.494 127.422 506.436 127.111 506.208 126.955L502.497 124.409C502.269 124.253 501.958 124.311 501.802 124.539C501.646 124.767 501.704 125.078 501.932 125.234L505.23 127.496L502.968 130.795C502.811 131.023 502.869 131.334 503.097 131.49C503.325 131.646 503.636 131.588 503.792 131.361L506.338 127.65ZM343.179 158.198L345.574 157.752L345.391 156.769L342.996 157.215L343.179 158.198ZM350.363 156.86L355.153 155.967L354.97 154.984L350.18 155.876L350.363 156.86ZM359.942 155.075L364.731 154.183L364.548 153.199L359.759 154.092L359.942 155.075ZM369.521 153.29L374.31 152.398L374.127 151.415L369.338 152.307L369.521 153.29ZM379.099 151.506L383.889 150.613L383.706 149.63L378.916 150.522L379.099 151.506ZM388.678 149.721L393.468 148.829L393.284 147.845L388.495 148.738L388.678 149.721ZM398.257 147.936L403.046 147.044L402.863 146.061L398.074 146.953L398.257 147.936ZM407.836 146.151L412.625 145.259L412.442 144.276L407.652 145.168L407.836 146.151ZM417.414 144.367L422.204 143.474L422.02 142.491L417.231 143.384L417.414 144.367ZM426.993 142.582L431.782 141.69L431.599 140.707L426.81 141.599L426.993 142.582ZM436.572 140.797L441.361 139.905L441.178 138.922L436.388 139.814L436.572 140.797ZM446.15 139.013L450.94 138.12L450.756 137.137L445.967 138.03L446.15 139.013ZM455.729 137.228L460.518 136.336L460.335 135.353L455.546 136.245L455.729 137.228ZM465.308 135.443L470.097 134.551L469.914 133.568L465.124 134.46L465.308 135.443ZM474.886 133.659L479.676 132.766L479.492 131.783L474.703 132.676L474.886 133.659ZM484.465 131.874L489.254 130.982L489.071 129.999L484.282 130.891L484.465 131.874ZM494.044 130.089L498.833 129.197L498.65 128.214L493.86 129.106L494.044 130.089ZM503.622 128.305L506.017 127.858L505.834 126.875L503.439 127.322L503.622 128.305Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter3_d_5404_8375)">
            <rect
              id="B-Background"
              x="591.789"
              y="168.794"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 591.789 168.794)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M608.583 145.774L605.296 145.742L605.296 143.932L608.055 143.958C608.542 143.963 608.941 143.905 609.252 143.785C609.564 143.659 609.797 143.476 609.952 143.238C610.112 142.993 610.194 142.695 610.198 142.343C610.201 141.945 610.128 141.622 609.978 141.374C609.834 141.127 609.604 140.946 609.289 140.832C608.98 140.718 608.579 140.658 608.087 140.653L606.259 140.636L606.157 151.367L603.52 151.342L603.641 138.546L608.106 138.588C608.85 138.595 609.515 138.672 610.099 138.818C610.69 138.964 611.189 139.183 611.596 139.474C612.003 139.765 612.313 140.131 612.526 140.572C612.739 141.008 612.842 141.525 612.837 142.122C612.832 142.65 612.707 143.135 612.462 143.578C612.224 144.021 611.848 144.381 611.336 144.657C610.829 144.933 610.169 145.083 609.354 145.104L608.583 145.774ZM608.416 151.388L604.522 151.352L605.57 149.305L608.435 149.332C608.898 149.336 609.276 149.267 609.571 149.123C609.865 148.973 610.084 148.77 610.227 148.514C610.37 148.257 610.443 147.962 610.446 147.628C610.45 147.253 610.389 146.927 610.262 146.651C610.142 146.374 609.945 146.161 609.671 146.012C609.397 145.857 609.034 145.778 608.583 145.774L606.043 145.749L606.078 143.939L609.242 143.969L609.841 144.687C610.621 144.682 611.246 144.826 611.718 145.118C612.196 145.403 612.541 145.773 612.754 146.226C612.972 146.679 613.079 147.164 613.074 147.679C613.066 148.5 612.881 149.189 612.518 149.749C612.155 150.302 611.627 150.716 610.933 150.99C610.245 151.265 609.406 151.398 608.416 151.388Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M519.814 123.864C519.658 124.091 519.716 124.403 519.944 124.559L523.655 127.104C523.882 127.26 524.194 127.202 524.35 126.975C524.506 126.747 524.448 126.436 524.22 126.279L520.922 124.017L523.184 120.718C523.34 120.491 523.282 120.179 523.055 120.023C522.827 119.867 522.516 119.925 522.36 120.153L519.814 123.864ZM683.189 94.1432C683.345 93.9155 683.287 93.6043 683.06 93.4481L679.349 90.9028C679.121 90.7466 678.81 90.8045 678.653 91.0323C678.497 91.26 678.555 91.5712 678.783 91.7274L682.082 93.9899L679.819 97.2886C679.663 97.5163 679.721 97.8275 679.949 97.9837C680.176 98.1399 680.488 98.0819 680.644 97.8542L683.189 94.1432ZM520.318 124.638L522.709 124.193L522.525 123.21L520.135 123.655L520.318 124.638ZM527.489 123.302L532.27 122.411L532.087 121.428L527.306 122.319L527.489 123.302ZM537.051 121.52L541.832 120.63L541.649 119.646L536.868 120.537L537.051 121.52ZM546.613 119.739L551.394 118.848L551.211 117.865L546.43 118.756L546.613 119.739ZM556.175 117.957L560.956 117.067L560.773 116.083L555.992 116.974L556.175 117.957ZM565.737 116.176L570.517 115.285L570.334 114.302L565.553 115.193L565.737 116.176ZM575.298 114.394L580.079 113.503L579.896 112.52L575.115 113.411L575.298 114.394ZM584.86 112.613L589.641 111.722L589.458 110.739L584.677 111.63L584.86 112.613ZM594.422 110.831L599.203 109.94L599.02 108.957L594.239 109.848L594.422 110.831ZM603.984 109.05L608.765 108.159L608.581 107.176L603.801 108.067L603.984 109.05ZM613.546 107.268L618.326 106.377L618.143 105.394L613.362 106.285L613.546 107.268ZM623.107 105.487L627.888 104.596L627.705 103.613L622.924 104.503L623.107 105.487ZM632.669 103.705L637.45 102.814L637.267 101.831L632.486 102.722L632.669 103.705ZM642.231 101.923L647.012 101.033L646.829 100.05L642.048 100.94L642.231 101.923ZM651.793 100.142L656.574 99.2512L656.39 98.2681L651.609 99.1588L651.793 100.142ZM661.354 98.3604L666.135 97.4696L665.952 96.4865L661.171 97.3773L661.354 98.3604ZM670.916 96.5789L675.697 95.6881L675.514 94.705L670.733 95.5958L670.916 96.5789ZM680.478 94.7973L682.868 94.3519L682.685 93.3689L680.295 93.8142L680.478 94.7973Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter4_d_5404_8375)">
            <rect
              id="A-Background"
              x="763.67"
              y="63.3977"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 763.67 63.3977)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M745.653 36.8163L742.173 47.4247H739.369L744.124 34.6278H745.908L745.653 36.8163ZM748.545 47.4247L745.056 36.8163L744.774 34.6278H746.576L751.357 47.4247H748.545ZM748.387 42.661V44.7264H741.628V42.661H748.387Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M706.018 63.4162C706.192 63.6303 706.507 63.6624 706.721 63.4879L710.209 60.645C710.423 60.4706 710.456 60.1556 710.281 59.9415C710.107 59.7275 709.792 59.6954 709.578 59.8698L706.477 62.3969L703.95 59.2962C703.775 59.0822 703.461 59.0501 703.246 59.2245C703.032 59.399 703 59.7139 703.175 59.928L706.018 63.4162ZM712.068 11.0304C711.894 10.8164 711.579 10.7843 711.365 10.9587L707.876 13.8016C707.662 13.9761 707.63 14.291 707.805 14.5051C707.979 14.7191 708.294 14.7512 708.508 14.5768L711.609 12.0498L714.136 15.1504C714.31 15.3645 714.625 15.3966 714.839 15.2221C715.053 15.0477 715.085 14.7327 714.911 14.5187L712.068 11.0304ZM706.903 63.151L707.166 60.5633L706.172 60.4619L705.908 63.0496L706.903 63.151ZM707.694 55.3879L708.222 50.2125L707.227 50.1111L706.699 55.2865L707.694 55.3879ZM708.749 45.0371L709.277 39.8617L708.282 39.7603L707.754 44.9357L708.749 45.0371ZM709.804 34.6863L710.332 29.5109L709.337 29.4095L708.809 34.5849L709.804 34.6863ZM710.859 24.3355L711.387 19.1601L710.392 19.0587L709.864 24.2341L710.859 24.3355ZM711.914 13.9847L712.178 11.397L711.183 11.2956L710.919 13.8833L711.914 13.9847Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5404_8375"
          x="-5.52246"
          y="71.9047"
          width="113.139"
          height="113.139"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5404_8375" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5404_8375"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5404_8375"
          x="194.325"
          y="169.507"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5404_8375" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5404_8375"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5404_8375"
          x="377.284"
          y="134.511"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5404_8375" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5404_8375"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_5404_8375"
          x="554.279"
          y="100.978"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5404_8375" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5404_8375"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_5404_8375"
          x="692.881"
          y="-1.54846"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5404_8375" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5404_8375"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default RectangleTwoBreaks
